/**
 * DOM Utilities for Template Two
 * Handles form label manipulation and element repositioning
 */

/**
 * Updates form field placeholders from labels and removes labels
 * Handles text inputs, select dropdowns, and required field indicators
 */
export const updateFormLabelsAndPlaceholders = () => {
    document.querySelectorAll("#applyForm .ant-form-item .ant-form-item-label label").forEach((label) => {
        const inputId = label.getAttribute("for");
        if (inputId) {
            const input = document.getElementById(inputId);
            const hasRequired = label.className.includes('ant-form-item-required');
            if (input) {
                if (input.type === 'text') {
                    input.placeholder = label.textContent.trim() + (hasRequired ? ' *' : '');
                    label.remove(); // Delete label after update placeholder
                } else if (input.type === 'search') {
                    const selectWrapper = input.closest('.ant-select');
                    if (selectWrapper) {
                        const placeholderSpan = selectWrapper.querySelector('.ant-select-selection-placeholder');
                        if (placeholderSpan) {
                            placeholderSpan.textContent = label.textContent.trim() + (hasRequired ? ' *' : '');
                            label.remove();
                        }
                    }
                } else if (input.tagName === 'DIV' && hasRequired) {
                    label.classList.remove('ant-form-item-required')
                    label.textContent = label.textContent.trim() + (hasRequired ? ' *' : '');
                }
            }
        }
    });
};

/**
 * Repositions privacy elements for mobile layout
 * Moves .preview-row-nine-container before footer elements
 */
const repositionPrivacyElementsMobile = () => {
    const target1 = document.querySelector(".preview-row-nine-container");
    const reference1 = document.querySelector(".footer-container");
    const reference2 = document.querySelector(".footer23");
    const reference3 = document.querySelector(".koch-nationalease .footer22");
    
    if (target1 && reference1) {
        reference1.parentNode.insertBefore(target1, reference1);
    }
    if (target1 && reference3) {
        reference3.parentNode.insertBefore(target1, reference3);
    } else {
        if (target1 && reference2) {
            reference2.parentNode.insertBefore(target1, reference2);
        }
    }
};

/**
 * Repositions privacy elements for desktop layout
 * Moves .preview-row-nine-container and related footer elements
 */
const repositionPrivacyElementsDesktop = () => {
    const target = document.querySelector(".preview-row-nine-container");
    const reference = document.querySelector(".footer-section > .footer-section-inner");

    if (target && reference) {
        reference.parentNode.insertBefore(target, reference.nextSibling);
    }

    // Standard footer elements
    const arrElem = [
        '.preview-row-nine-container', 
        '.footer-section > .footer-wrapper', 
        '.footer-section > .footer-info',
    ];
    for (const element of arrElem) {
        const target = document.querySelector(element);
        const destination = document.querySelector(".footer-section");

        if (target && destination) {
            destination.appendChild(target);
        }
    }

    // Owner-operator specific elements
    const arrOOElem = [
        '.preview-row-nine-container', 
        '.ptl-owner-operator-page .footer-section1 > .footer-content1', 
        '.footer-section1 > .footer-container',
    ];
    for (const element of arrOOElem) {
        const target = document.querySelector(element);
        const destination = document.querySelector(".footer-section1");

        if (target && destination) {
            destination.appendChild(target);
        }
    }

    // Koch Nationalease specific handling
    const target_koch = document.querySelector('.preview-row-nine-container');
    const destination_koch = document.querySelector(".koch-nationalease .footer23");

    if (destination_koch && target_koch) {
        destination_koch.parentNode.insertBefore(target_koch, destination_koch);
        const whyChooseUs = document.querySelector('.why-choose-us');
        if (whyChooseUs) {
            whyChooseUs.style.height = 'auto';
        }
    }
};

/**
 * Repositions privacy and footer elements based on screen size
 * Handles both mobile and desktop layouts
 */
export const repositionPrivacyElements = () => {
    if (window.innerWidth <= 768) {
        repositionPrivacyElementsMobile();
    } else {
        repositionPrivacyElementsDesktop();
    }
};

/**
 * Setup DOM event handlers for hire.drivejrschugel.com
 * Handles mobile menu, navigation, and CTA button scrolling
 */
export const setupDriveJRSchugel = () => {

  var menuIcon = document.querySelector(".component-3-icon");
  var mobileOnly = document.querySelector(".mobile-only");
  var menuDrivers = document.querySelector(".menu-drivers");
  var drivingCareers = document.querySelector(".driving-careers-mobile");
  var closeMenu = document.querySelector(".close");
  if (menuIcon) {
    menuIcon.addEventListener("click", function () {
      toggleDisplay(mobileOnly);

      if (mobileOnly && mobileOnly.style.display === "none") {
        toggleDisplay(menuDrivers, "hide");
      }

      syncMenuDriversVisibility();
    });
  }

  if (closeMenu) {
    closeMenu.addEventListener("click", function () {
      toggleDisplay(mobileOnly, "hide");
      toggleDisplay(menuDrivers, "hide");
    });
  }

  var mobileMenuItems = document.querySelectorAll(".menu > li");
  if (mobileMenuItems.length > 0) {
    mobileMenuItems.forEach(function (item) {
      // Toggle active class on click
      item.addEventListener("click", function () {
        if (item.classList.contains("active")) {
          item.classList.remove("active");
          syncMenuDriversVisibility();
          return;
        }

        mobileMenuItems.forEach(function (menuItem) {
          menuItem.classList.remove("active");
        });
        item.classList.add("active");
        syncMenuDriversVisibility();
      });
    });
  }
  var mobileMenuDriversItems = document.querySelectorAll(".menu-drivers > li");
  if (mobileMenuDriversItems.length > 0) {
    mobileMenuDriversItems.forEach(function (item) {
      // Toggle active class on click
      item.addEventListener("click", function () {
        if (item.classList.contains("active")) {
          item.classList.remove("active");
          return;
        }

        mobileMenuDriversItems.forEach(function (menuItem) {
          menuItem.classList.remove("active");
        });
        item.classList.add("active");
      });
    });
  }


  var button = document.getElementById("button");
  if (button) {
    button.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var buttonContainer = document.getElementById("buttonContainer");
  if (buttonContainer) {
    buttonContainer.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var button2 = document.getElementById("button2");
  if (button2) {
    button2.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var button3 = document.getElementById("button3");
  if (button3) {
    button3.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var button4 = document.getElementById("button4");
  if (button4) {
    button4.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var button5 = document.getElementById("button5");
  if (button5) {
    button5.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var button6 = document.getElementById("button6");
  if (button6) {
    button6.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var buttonImage = document.getElementById("buttonImage");
  if (buttonImage) {
    buttonImage.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  var buttonImage1 = document.getElementById("buttonImage1");
  if (buttonImage1) {
    buttonImage1.addEventListener("click", function () {
      var anchor = document.querySelector("[data-scroll-to='cTASection']");
      if (anchor) {
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    });
  }

  function toggleDisplay(target, forceState) {
    if (!target) {
      return;
    }

    if (forceState === "show") {
      target.style.display = "block";
      return;
    }

    if (forceState === "hide") {
      target.style.display = "none";
      return;
    }
    if (target.style.display === "block") {
      target.style.display = "none";
    } else {
      target.style.display = "block";
    }
  }

  function syncMenuDriversVisibility() {
    if (!menuDrivers || !drivingCareers) {
      return;
    }

    if (mobileOnly && mobileOnly.style.display === "none") {
      menuDrivers.style.display = "none";
      return;
    }

    if (drivingCareers.classList.contains("active")) {
      menuDrivers.style.display = "block";
    } else {
      menuDrivers.style.display = "none";
    }
  }

  var clientId12Images = document.querySelectorAll(".client-id-12 img");
  clientId12Images.forEach(function (img) {
    img.addEventListener("click", function () {
      if (img.src.includes("JRS-HORIZONTAL")) {
        window.location.href = "/";
      }
    });
  });
};
